'use strict';
var App = (function() {
    var $html,
        $body = $('body'),
        loader = '<div class="loader"></div>',
        show_loader = true;
    var $grid;
    var slides;
    var _sessionId;

    function init( options ) {

        var defaults = {};
        var settings = $.extend({}, defaults, options);

        $html = $(document.documentElement).removeClass('no-js').addClass('js');
        this.interfaceName = $(document.body).data('interface-name');
        if ( location.toString().match(/SESS_ID=(\d+)/) ) {
            _sessionId = RegExp.$1;
        }
    }

    function showActivity() {
        if (show_loader) {
            if ( $.fancybox ) {
                $.fancybox.showLoading();  // v.2
            } else {
                $body.append(loader);
            }
        }
    }

    function hideActivity() {
        if ( $.fancybox ) {
            $.fancybox.hideLoading();  // v.2
        } else {
            $('.loader').remove();
        }
    }

    function getCssSize( element, property ) {
        return parseFloat( $(element).css(property).replace('%', '') );
    }

    function getJSON( action, data, handler, options ) {
        App.showActivity();
        if ( _sessionId ) {
            data.SESS_ID = _sessionId;
        }
        var url = '/json/' + action + '/';
        var errorMessage = 'Произошла ошибка при загрузке данных. Попробуйте перезагрузить страницу.';
        var settings = $.extend({
            method:    'POST',
            data:       data,
            dataType:  'json',
            checkStatus: true,
            error: function() {
                alert(errorMessage);
            },
            complete: function() {
                App.hideActivity();
            }
        }, options || {});

        settings.success = function( data, textStatus, jqXHR ) {
            if ( !settings.checkStatus || data.status ) {
                handler(data, textStatus, jqXHR);
            } else {
                alert(errorMessage);
            }
        };
        return $.ajax(url, settings);
    }

    function initSlider(selector, params) {
        //console.log('Init Slick: ', selector, params);
        $(selector).slick(params);
    }

    function contentPopup(selector) {
        $(selector).on('click', function(e){
            e.preventDefault();
            e.stopImmediatePropagation();
            var class_name = $(this).data('class_name');
            var object_id = $(this).data('object_id');
            var item_id = $(this).data('item_id');

            var wrap = '<div class="popup"><div class="popup__wrap">'+
                       '<a href="#" class="popup__close js-popup-close">— закрыть</a>' +
                       '<div class="popup__inner">' +
                       '<div class="popup__body"></div>'
                       '</div></div></div>';
            $('body').addClass('m--popup').append(wrap);
            $('.popup').fadeIn(500, function(){
                $(selector+'-close').on('click', function(e){
                    console.log('Close');
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $('.popup').fadeOut(function(){
                        $('.popup').remove();
                        $('body').removeClass('m--popup');
                    });
                });
            });

            App.getJSON('get_'+class_name, { 'object_id': object_id, 'item_id': item_id }, function(data) {
                if (data.status == 'ok') {
                    //$('.popup').find('.popup__title').html(data.title);
                    $('.popup').find('.popup__body').append(data.html);
                    //$('input[type=checkbox], input[type=radio], input[type=file], select').styler();

                    var $form = $('.popup').find('form');
                    $form.ajaxForm({
                        beforeSend: function(){
                            $form.find(".has-error").removeClass("has-error");
                            $form.find(".form__remark").addClass('m--hidden');
                            App.showActivity();
                        },
                        success: function(e){
                            App.hideActivity();
                            answer(e);
                        },
                        error: function(e){
                            App.hideActivity();
                        },
                        type: 'POST',
                        dataType: 'json',
                        url: '/json/submit_form/',
                    });

                }
            });

        });

        function answer(json) {
            var $form = $('.popup').find('form');
            if(json.status == 'ok'){
                if(json.errors){
                    for(var i=0;i<json.errors.length;i++){
                        var attr = ".attr-"+json.errors[i];
                        $form.find(attr).addClass("has-error");
                    }
                    $form.find(".form__remark").removeClass('m--hidden');
                }else{
                    $form.html(json.html);
                }
            }
        }
    }

    function advantagesSlider(selector) {
        var params = {
            touchMove: true,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: false,
            arrows: true,
            prevArrow: '<a href="#" class="arrows__prev">›</a>',
            nextArrow: '<a href="#" class="arrows__next">›</a>',
            fade: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            swipeToSlide: true,
            adaptiveHeight: false,
            centerMode: false,
            variableWidth: true,
            appendArrows: selector+'-arrows',
            //variableWidth: true,
            slide: '.slider__item',

            responsive: [
                {
                    breakpoint: 1599,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 779,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]

        };
        App.initSlider(selector, params);
    }

    function partnersSlider(selector) {
        $(selector).each(function(){
            var slider = $(this).attr('id');
            var params = {
                touchMove: true,
                autoplay: true,
                autoplaySpeed: 5000,
                dots: false,
                arrows: true,
                prevArrow: '<a href="#" class="arrows__prev m--white">›</a>',
                nextArrow: '<a href="#" class="arrows__next m--white">›</a>',
                fade: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true,
                adaptiveHeight: false,
                centerMode: false,
                variableWidth: false,
                appendArrows: '#'+slider+' .arrows',
                //variableWidth: true,
                slide: '.gallery__item',
            };
            App.initSlider('#'+slider, params);
            $('#'+slider).on('beforeChange', function(event, slick, currentSlide, nextSlide){
                //console.log(slick);
                var $nav = $(slick.$slider).siblings(selector+'-nav').find('li');
                $nav.removeClass('is-active');
                $nav.eq(nextSlide).addClass('is-active');
                //console.log($nav);
            });
            $('#'+slider).siblings(selector+'-nav').find('li').on('click', function(e){
                e.preventDefault();
                $('#'+slider).siblings(selector+'-nav').find('li').removeClass('is-active');
                $(this).addClass('is-active');
                var ind = $(this).index();
                //console.log(ind);
                $('#'+slider).slick('slickGoTo', ind);
            });
        });
    }

    function initMenu(selector){
        $(selector+'-burger').on('click', function(e){
            e.preventDefault();
            $(selector).toggleClass('is-open');
            $(this).toggleClass('is-open');
        });
        $(selector+'-scroll').on('click', function(e){
            var href = $(this).attr('href').split('#');
            if ((href[0] == window.location.pathname) || (href[0] == '')) {
                e.preventDefault();
                var hash = '#'+href[1];
                $('body, html').animate({ scrollTop: $(hash).offset().top }, 1000);
            }
            $(selector).removeClass('is-open');
            $(selector+'-burger').removeClass('is-open');
            $('body').removeClass('m--popup');
        });
    }

    function initTabs(selector){
        console.log($(selector));
        $(selector+'-item').on('click', function(e){
            e.preventDefault();
            console.log('Click tab');
            $(this).parents(selector).find(selector+'-item').removeClass('is-active');
            $(this).parents(selector).find(selector+'-block').removeClass('is-active');
            $(this).addClass('is-active');
            var id = $(this).data('id');
            if (id != undefined) {
                console.log('Ajax content');
                var object_id = $(this).data('object_id');
                var class_name = $(this).data('class_name');
                App.getJSON('get_'+class_name, { 'object_id': object_id, }, function(data) {
                    if (data.status == 'ok') {
                        $('#'+id).html(data.html);
                        $(selector+'-title').html(data.title);
                        $(selector+'-header').html(data.header);
                        $(selector+'-content').html(data.content);
                        $('#'+id).addClass('is-active');
                        App.contentPopup('.js-popup');
                    }
                });
            } else {
                id = $(this).attr('href');
                var $map = $(id).find('.map iframe');
                if ($map.length) {
                    $map.attr("src", $map.attr("src"));
                }
                $(id).addClass('is-active');
                if ($(id).find('.js-partners').length) {
                    console.log('slickPlay');
                    $(id).find('.js-partners').slick('slickGoTo', 0, true);
                }
            }
            $(this).parent().removeClass('is-open');
        });
        $(selector).find('.js-toggle').on('click', function(e){
            e.preventDefault();
            $(this).parent().toggleClass('is-open');
        });
    }

    function bottomForm(selector) {
        var $form = $(selector).find('form');
        console.log($form);
        $form.ajaxForm({
            beforeSend: function(){
                $form.find(".has-error").removeClass("has-error");
                $form.find(".form__remark").addClass('m--hidden');
                App.showActivity();
            },
            success: function(e){
                App.hideActivity();
                answer(e);
            },
            error: function(e){
                App.hideActivity();
            },
            type: 'POST',
            dataType: 'json',
            url: '/json/submit_form/',
        });

        function answer(json) {
            var $form = $(selector).find('form');
            if(json.status=="ok"){
                if(json.errors){
                    for(var i=0;i<json.errors.length;i++){
                        var attr = ".attr-"+json.errors[i];
                        $form.find(attr).addClass("has-error");
                    }
                    $form.find(".form__remark").removeClass('m--hidden');
                }else{
                    $form.html(json.html);
                }
            }
        }
    }

    function fixedHeader(selector){
        $(window).scroll(function() {
            if ($(this).scrollTop() > 1){  
                $(selector).addClass('is-fixed');
            }
            else{
                $(selector).removeClass('is-fixed');
            }
        });
    }
//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
    return {
        init:               init,
        showActivity:       showActivity,
        hideActivity:       hideActivity,
        getCssSize:         getCssSize,
        getJSON:            getJSON,
        initSlider:         initSlider,
        contentPopup:       contentPopup,
        advantagesSlider:   advantagesSlider,
        partnersSlider:     partnersSlider,
        initMenu:           initMenu,
        initTabs:           initTabs,
        bottomForm:         bottomForm,
        fixedHeader:        fixedHeader,
    }
})();
